import { useTranslation } from 'react-i18next';

import Button from '@/components/Button';
import {
	Dialog,
	DialogContent,
	DialogFooter,
	DialogTop
} from '@/components/Dialog';
import InfoIcon from '@/icons/info.svg';
import { cn } from '@/utils';

function ConfirmationModal({
	open,
	loading,
	onClose,
	onConfirm,
	title,
	text,
	confirmText,
	closeText,
	Icon = InfoIcon,
	fullIcon = false,
	...props
}) {
	const { t } = useTranslation();

	return (
		<Dialog open={open} onOpenChange={onClose} {...props}>
			<DialogContent className="w-[280px] md:w-[397px]">
				{title && <DialogTop title={title} />}
				<div className="grid justify-items-center gap-2 px-4 py-9">
					<Icon className={cn(!fullIcon && 'size-5 text-red')} />
					<p className="whitespace-pre-wrap text-center text-sm leading-6 text-grey-500">
						{text}
					</p>
				</div>
				<DialogFooter>
					<Button variant="outline" onClick={onClose}>
						{closeText || t('common.cancel')}
					</Button>
					<Button loading={loading} onClick={onConfirm}>
						{confirmText}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}

export default ConfirmationModal;
